var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rewards-card" }, [
    !_vm.selectedRewards.length
      ? _c("span", { staticClass: "gray--text" }, [
          _vm._v("\n    Selecione pelo menos 1 item para continuar\n    "),
          _c("span", { staticClass: "red--text" }, [_vm._v("*")]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rewards-card-list" },
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "rewards-card-list-item",
            class: { "is-active-item": _vm.isSelectedItem(item) },
            on: {
              click: function ($event) {
                return _vm.$emit("select-reward", item)
              },
            },
          },
          [
            _c("div", [
              _c("img", {
                staticClass: "mb-2",
                attrs: { src: item.img, width: "50" },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "icon-container",
                class: { active: item.isActive },
              },
              [
                _c("v-icon", { staticClass: "white--text mt-2 mb-2" }, [
                  _vm._v("\n          workspace_premium\n        "),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "mt-2 mb-2 item-title",
                staticStyle: { "text-align": "center" },
              },
              [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "pl-3 pr-3 mt-2 trigger" }, [
              _vm._v("\n        " + _vm._s(item.trigger) + "\n      "),
            ]),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btn-container" },
      [
        _c(
          "v-btn",
          {
            staticClass: "white--text",
            attrs: { disabled: _vm.disabledButton, color: "primary" },
            on: {
              click: function ($event) {
                return _vm.$emit("rescue-rewards")
              },
            },
          },
          [_vm._v("\n      RESGATAR BENEFÍCIOS\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }